<!--sidebar-->
<c-sidebar #sidebar="cSidebar" class="d-print-none sidebar sidebar-fixed" colorScheme="dark" id="sidebar" visible>
  <c-sidebar-brand [brandFull]="{
      src: 'assets/img/brand/campaign-management.svg',
      width: 190,
      height: 35,
      alt: 'Amway ABO Pool System'
    }" [brandNarrow]="{
      src: 'assets/img/brand/campaign-management-signet.svg',
      width: 46,
      height: 46,
      alt: 'Amway ABO Pool System'
    }" routerLink="./">
  </c-sidebar-brand>
  <c-sidebar-nav [navItems]="nav"> </c-sidebar-nav>
  @if (!sidebar.narrow) {
    <c-sidebar-toggler toggle="visible" cSidebarToggle="sidebar"></c-sidebar-toggler>
  }
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100 dark:bg-transparent">
  <!--app-header-->
  <app-default-header class="mb-4 d-print-none header header-sticky" position="sticky" sidebarId="sidebar">
  </app-default-header>
  <!--app-body-->
  <div class="body flex-grow-1 px-3">
    <c-container breakpoint="lg" class="h-auto">
      <router-outlet></router-outlet>
    </c-container>
  </div>
  <!--app footer-->
  <app-default-footer></app-default-footer>
</div>